import React, { useCallback } from 'react';
import { List, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import OntraccrTag from '../common/OntraccrTag';
import OntraccrCheckBox from '../common/inputs/OnTraccrCheckbox';
import { deleteUserFromCardWorkCompletion, toggleCardWorkCompletion } from './state/boards.actions';
import BorderlessButton from '../common/buttons/BorderlessButton';
import CustomConfirmModal from '../common/modals/CustomConfirmModal';

export default function BoardCardWorkCompletion({
  workCompletionUsers = [],
  userMap = {},
  cardId,
}) {
  const dispatch = useDispatch();

  const onToggleWorkCompletion = useCallback((workCompletionUser) => {
    const { userId, completed, notAssigned } = workCompletionUser;
    dispatch(toggleCardWorkCompletion(cardId, {
      userId,
      completed: !completed,
      notAssigned: !!notAssigned,
    }));
  }, [cardId]);

  const onDeleteWorkCompletion = useCallback((workCompletionUser) => {
    const { userId } = workCompletionUser;
    CustomConfirmModal({
      title: `Remove ${userMap[userId]?.name} from work completion?`,
      content: 'This user will no longer be marked as completed for this card. You can add them back by re-assigning them to the card.',
      onOk: () => {
        dispatch(deleteUserFromCardWorkCompletion(cardId, userId));
      },
    });
  }, [cardId, userMap]);

  return (
    <List
      dataSource={workCompletionUsers}
      renderItem={(workCompletionUser) => {
        const { userId, completed, notAssigned } = workCompletionUser;
        const fullUser = userMap[userId] || {};

        const name = fullUser.name || 'Unknown User';

        return (
          <List.Item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space align="center">
              <OntraccrCheckBox
                value={completed}
                onChange={() => onToggleWorkCompletion(workCompletionUser)}
                key={userId}
                style={{ marginLeft: 20 }}
              />
              <OntraccrTag
                color={completed ? 'green' : 'red'}
                style={{ border: '1px solid' }}
              >
                {completed ? 'Completed' : 'Incomplete'}
              </OntraccrTag>
              <span style={{ fontSize: 14, fontWeight: 500 }}>{name}</span>
            </Space>
            {notAssigned && (
              <Space>
                <BorderlessButton
                  iconNode={<CloseOutlined />}
                  onClick={() => onDeleteWorkCompletion(workCompletionUser)}
                />
              </Space>
            )}
          </List.Item>
        );
      }}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
BoardCardWorkCompletion.propTypes = {
  workCompletionUsers: PropTypes.array,
  userMap: PropTypes.object,
  cardId: PropTypes.string.isRequired,
};

BoardCardWorkCompletion.defaultProps = {
  workCompletionUsers: [],
  userMap: {},
};
